export default __webpack_public_path__ + "static/media/4.5f1725cf.jpg";